import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorDialogService } from './services';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ErrorDialogComponent } from './error-dialog.component';

@NgModule({
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  declarations: [ErrorDialogComponent],
  exports: [ErrorDialogComponent],
  providers: [ErrorDialogService],
})
export class ErrorDialogModule {}
